module.exports = __webpack_public_path__ + "static/media/18.a0939546.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/18.jpg
// module id = 193
// module chunks = 0